import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showMapView: false,
  selectedSiteIdForMapView: {
    siteId: null,
    siteIndex: -1
  },
  bottomSiteCardHeightWithIndexes: {}
};

export const siteMapSlice = createSlice({
  name: 'siteMap',
  initialState,
  reducers: {
    setShowMapView: (state, action) => {
      state.showMapView = action.payload;
    },
    setBottomSiteCardHeightWithIndexes: (state, action) => {
      state.bottomSiteCardHeightWithIndexes = action.payload;
    },
    setSelectedSiteIdOnMapView: (state, action) => {
      state.selectedSiteIdForMapView = action.payload;
    },
    resetMapState: (state) => {
      state.showMapView = false;
      state.selectedSiteIdForMapView = {
        siteId: null,
        siteIndex: -1
      };
    }
  }
});

const siteMapReducer = siteMapSlice.reducer;

export const siteMapActions = siteMapSlice.actions;
export default siteMapReducer;
